export const WEBSITE_URL = 'https://www.generationsmhw.com';